// cSpell: ignore onlinepages, putaoid, picbook, weixin, kidslearning, inapp, vipbingo, cancle
import React from "react";
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Utils } from '../../utils/Utils';
import { COURSE_API } from "../../utils/Req";
import { reqAPI } from '../../server/reqAPI';
import { abnormalReporting } from '../../server/commonFun';
import { MoreSettingItems } from '../../static/json/setting-data';
import ChooseLevel from "../../components/dialog/ChooseLevel";
import ClearHistory from '../../components/dialog/ClearHistory';
import DeviceManagement from '../../components/Device/DeviceManagement';
import { getNeedShowChooseLevel } from '../../server/commonFun';
import { getUserInfo, setUserStorage } from '../../server/commonFun';

import { SettingData } from './test-json';

import { Flex } from "../../lib/components/LessonPath/static/style";
import request from '../../lib/request';
import utils from '../../lib/utils';
import { putaoWS } from '../../lib/ws';

const ua = navigator.userAgent.toLocaleLowerCase();
window.isApp = ua.indexOf('kidslearning_inapp_web') > -1 || ua.indexOf('kidslearning_vipbingo_web') > -1 ? true : false;
window.canSocket = window.isApp && ua.indexOf('1.0.0') === -1 ? true : false;

export default class Setting extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            pauseButton: 0,  // 课中可暂停
            recordStatus: -1,    // 课中可录屏；-1 不显示；0 不录屏； 1 录屏
            useLowCourseResource: window.localStorage.getItem('useLowCourseResource') && window.localStorage.getItem('useLowCourseResource') === "true", // 使用低画质课件资源 
            showChooseLevel: false,
            showClearHistoryDialog: false,
            showMoreSettingItems: false, // 显示更多设置
            showDeviceManagement: false, // 是否显示设备管理
        };

        this.putaoid = Utils.getCookie("putaoid");
        this.token = encodeURIComponent(Utils.getCookie("token"));
        this.cancleHandler = this.cancleHandler.bind(this);
    }

    componentDidMount() {
        const that = this;
        // 获取用户信息
        that.handleGetSettingData();   // 获取设置页的配置信息

        getUserInfo(that.context.user).then((data) => {
            if (data.code === 200) {
                this.setState({
                    pauseButton: data.pauseButton,
                    userInfoData: data,
                    level: data.course_position.level,
                }, () => {
                    setUserStorage(data);
                });
            } else if (data.code === 499) {
                window.location = `#/login`;
            }
        });

        let localRecordStatus = window.localStorage.getItem('recordStatus') && parseInt(window.localStorage.getItem('recordStatus'));
        putaoWS.getOsInfo((content) => {    // 获取客户端信息
            that.setState({
                recordStatus: typeof localRecordStatus === "number" && !isNaN(localRecordStatus) ? localRecordStatus : (content.recordStatus ? 1 : 0),
            }, () => {
                window.localStorage.setItem('recordStatus', this.state.recordStatus);
            });
        });
    }

    // 获取设置数据
    handleGetSettingData() {
        // this.setState({
        //     settingData: SettingData.data
        // });
        request(reqAPI.setting_data_v2, this.context.user, { method: 'GET' })
            .then(res => res.json())
            .then(res => {
                if (res.data && res.code && res.code === 200) {
                    this.setState({
                        settingData: res.data
                    });
                } else {
                    abnormalReporting({
                        putaoid: this.context.user.putaoid,
                        url: reqAPI.setting_data_v2,
                        type: 'data',
                        res
                    });
                }
            });
    }

    // 课中可暂停处理函数
    handleChangePause() {
        const that = this;
        const { pauseButton } = this.state
        fetch(
            `${COURSE_API.pause_button}?putaoid=${that.putaoid}&token=${that.token}&value=${pauseButton ? 0 : 1}&from=pc`,
            { method: "GET" }
        )
            .then(res => res.json())
            .then(data => {
                if (data.code === 200) {
                    that.setState({
                        pauseButton: pauseButton ? 0 : 1
                    });
                } else if (data.code === 499) {
                    window.location = `#/login`;
                }
            });
    }

    // 课中录屏处理函数
    handleChangeRecord() {
        const that = this;
        const { recordStatus } = this.state;
        this.setState({
            recordStatus: recordStatus ? 0 : 1
        }, () => {
            window.localStorage.setItem('recordStatus', this.state.recordStatus);
            that.state.recordStatus === 1 && window.localStorage.removeItem('sereenRecordneverNotify');
        });
    }

    // 使用低画质课件资源处理函数
    handleUseLowCourseResource() {
        const { useLowCourseResource } = this.state;

        this.setState({
            useLowCourseResource: !useLowCourseResource
        }, () => {
            window.localStorage.setItem('useLowCourseResource', this.state.useLowCourseResource);
        });
    }

    // 获取开关变量状态
    getSwitchVariable(type) {
        let flag = false;

        switch (type) {
            case 'course_pause':
                flag = this.state.pauseButton;
                break;
            case 'course_record':
                flag = this.state.recordStatus;
                break;
            case 'use_low_course_resource':
                flag = this.state.useLowCourseResource;
                break;
            default: flag = false;
        }

        return flag;
    }

    handleClickSettingItem(item, e) {
        e && e.stopPropagation();
        const that = this;
        const { level } = this.state;

        if (!item || !item.type) {
            if (item && item.url) {
                window.location = item.url;
            } else {
                return;
            }
        }

        switch (item.type) {
            case 'gift':
                window.location.href = `#/my-gift?level=${level}`;
                break;
            case 'list_device':
                window.location.href = '#/device';
                break;
            case 'list_weixin':
                window.location = `#/bind-weixin`;
                break;
            case 'set_password':
                window.location = `#/set-password`;
                break;
            case 'list_more':
                this.setState({ showMoreSettingItems: true });
                break;
            case 'course_pause':
                that.handleChangePause();
                break;
            case 'course_record':
                that.handleChangeRecord();
                break;
            case 'use_low_course_resource':
                that.handleUseLowCourseResource();
                break;
            case 'device_management':
                that.handleShowDeviceManagement();
                break;
            case 'clear_history':
                this.setState({ showClearHistoryDialog: true });
                break;
            default: window.location = (item.url ? item.url : '')
        }
    }

    handleShowDeviceManagement = () => {
        this.setState({
            showDeviceManagement: true
        });
    }

    handleDeviceManagementBack = () => {
        this.setState({
            showDeviceManagement: false
        });
    }

    // 退出登录
    settingLogout = () => {
        this.context.clearUser();
        Utils.delCookie("putaoid", window.location.hostname, "/");
        Utils.delCookie("token", window.location.hostname, "/");

        window.location = `#/login`;
    }

    // 点击返回按钮
    clickBackButton = () => {
        const { showMoreSettingItems } = this.state;

        if (showMoreSettingItems) {
            this.setState({
                showMoreSettingItems: !showMoreSettingItems
            });
        } else {
            window.history.back();
        }
    }

    // 点击剩余学习的处理函数
    handleClickClassNum(url) {
        const that = this;

        getNeedShowChooseLevel(that.context.user).then(res => {
            if (res.code && res.code === 200 && res.data && res.data.residueCourseNum) {
                that.setState({
                    showChooseLevel: true,
                    levelInfo: res.data
                });
            } else {
                window.location = url;
            }
        });
    }

    // 开通成功
    handleSuccessChooseLevel() {
        this.setState({
            needChooseLevel: false
        });
        window.location = `/onlinepages/course_assist/class_details/?v=${Math.floor(Math.random() * 1000)}`/*that.setState({ showClassNumDialog: true })*/
    }

    // 关闭选择开课节点弹窗
    handleChooseLevelClose() {
        this.setState({
            showChooseLevel: false
        });
    }

    cancleHandler() {
        this.setState({
            showClearHistoryDialog: false
        });
    }

    render() {
        const that = this;
        const { settingData, showChooseLevel, levelInfo, userInfoData, showClearHistoryDialog, showMoreSettingItems, recordStatus, showDeviceManagement } = this.state;

        return (
            <SettingStyled>
                <BackButton onClick={that.clickBackButton} />
                {userInfoData && settingData && !showMoreSettingItems &&
                    <BaseSetting>
                        {/* 基础设置 */}
                        <UserInfo>
                            <Photo
                                src={userInfoData.photo || `https://webres.putaoabc.com/course/images/common/taotao.png`}
                                borderSrc={settingData.abilityMedalId &&
                                    `https://webres.putaoabc.com/course/images/medal/avatar_${settingData.abilityMedalId}.png`}
                                onClick={() => {
                                    this.handleClickSettingItem({
                                        url: `#/baby-info`
                                    })
                                }}
                            />
                            <Gender gender={userInfoData.gender} />
                            <Name>
                                <span>{userInfoData.eng_name || ''}</span>
                                {/* <span>{userInfoData.age || ''}岁</span> */}
                            </Name>
                            <Message
                                onClick={() => {
                                    this.handleClickSettingItem(settingData.notify || {
                                        url: `/onlinepages/course_assist/message/?v=${Math.random()}`
                                    })
                                }}
                            >
                                {
                                    settingData.notify && settingData.notify.notifyNum ?
                                        <span>{settingData.notify.notifyNum}</span>
                                        : null
                                }
                            </Message>
                        </UserInfo>

                        <AchievementBox>
                            {settingData.remainingLessons &&
                                <AchievementItem
                                    onClick={() => this.handleClickClassNum(settingData.remainingLessons.url)}
                                >
                                    <div>{settingData.remainingLessons.value || 0}</div>
                                    <div>剩余节数</div>
                                </AchievementItem>
                            }
                            {settingData.integrals &&
                                <AchievementItem
                                    // unClickable={true}
                                    onClick={() => this.handleClickSettingItem({
                                        url: settingData.integrals.url || null
                                    })}
                                >
                                    <div>{settingData.integrals.value || 0}</div>
                                    <div>金币</div>
                                </AchievementItem>
                            }
                            {settingData.encourage &&
                                <AchievementItem
                                    onClick={() => this.handleClickSettingItem({
                                        url: settingData.encourage.url || null
                                    })}
                                >
                                    <div>{settingData.encourage.value || 0}</div>
                                    <div>成就勋章</div>
                                </AchievementItem>
                            }
                        </AchievementBox>

                        {settingData.courseItems && Array.isArray(settingData.courseItems) &&
                            <H5BannerBox>
                                {settingData.courseItems.map((item, index) =>
                                    <H5BannerItem
                                        key={index}
                                        onClick={() => { this.handleClickSettingItem(item) }}
                                    >
                                        <H5BannerItemPhoto src={item.icon} />
                                        <div>{item.text}</div>
                                    </H5BannerItem>
                                )}
                            </H5BannerBox>
                        }

                        {settingData.promotion && settingData.promotion.items && Array.isArray(settingData.promotion.items) &&
                            <PhotoBannerBox>
                                <PhotoBannerHeader>
                                    <PhotoBannerHeaderText>{settingData.promotion.title || ''}</PhotoBannerHeaderText>
                                    <PhotoBannerHeaderH5 onClick={() => { this.handleClickSettingItem({ url: settingData.promotion.url || '' }) }}>
                                        <H5Icon icon={settingData.promotion.icon || ''} />
                                        <div>{settingData.promotion.text || ''}</div>
                                        <H5IconGo />
                                    </PhotoBannerHeaderH5>
                                </PhotoBannerHeader>
                                <PhotoBannerContainer>
                                    {settingData.promotion.items.map((item, index) =>
                                        <PhotoBannerItem
                                            key={index}
                                            type={item.type}
                                            icon={item.icon}
                                            onClick={() => { this.handleClickSettingItem(item) }}
                                        >
                                            {/* <div><span>{item.content || 0}</span><span>{item.auxText || ''}</span></div> */}
                                            <div />
                                            <div>{item.description || ''}</div>
                                            <div
                                                onClick={e => { this.handleClickSettingItem({ url: item.buttonUrl || '' }, e) }}
                                            >
                                                {item.text || ''}
                                            </div>
                                        </PhotoBannerItem>
                                    )}
                                </PhotoBannerContainer>
                            </PhotoBannerBox>
                        }

                        {settingData.settingItems && Array.isArray(settingData.settingItems) && settingData.settingItems.map((List, i) =>
                            <SettingCard key={i}>
                                {List && Array.isArray(List) && List.map((item, j) => {
                                    return (
                                        <ListItem
                                            key={j}
                                            icon={item.icon}
                                            onClick={() => { that.handleClickSettingItem(item) }}
                                            hasArrow={item.type === 'list_weixin' ? false : true}
                                        >
                                            {item.type === 'list_weixin' ? <Pause className={item.open ? "on" : ""}><span /></Pause> : null}
                                            {item.text}
                                        </ListItem>
                                    )
                                }
                                )}
                            </SettingCard>
                        )}
                    </BaseSetting>
                }
                {
                    showMoreSettingItems &&
                    <MoreSetting>
                        {/* 更多设置 */}
                        {/* 
                            1. promotion下添加icon和text字段。分别表示"推荐有奖 赢好礼"后面的icon和积分数。
                            2. promotion下的items里的每个元素，添加新字段buttonUrl，表示button点出的url。原来的url表示卡片点出的url。
                        */}
                        <MoreSettingTitle>设置</MoreSettingTitle>
                        <SettingCard>
                            {MoreSettingItems && Array.isArray(MoreSettingItems) && MoreSettingItems.map((item, index) => {
                                return (
                                    item.type === 'clear_history' && !window.canSocket ?
                                        null
                                        : item.type === 'course_record' && recordStatus === -1 ?
                                            null
                                            : <ListItem
                                                key={index}
                                                icon={require(`../../static/img/set_img/${item.type}.png`)}
                                                onClick={() => { that.handleClickSettingItem(item) }}
                                                hasArrow={item.hasArrow}
                                            >
                                                {!item.hasArrow ?
                                                    <Pause className={
                                                        this.getSwitchVariable(item.type) ? "on" : ""}
                                                    >
                                                        <span />
                                                    </Pause>
                                                    : null
                                                }
                                                {item.text}
                                            </ListItem>
                                )
                            })}
                        </SettingCard>
                        <MoreSettingPhone>当前账号：{(userInfoData && userInfoData.phoneNum) || ''}</MoreSettingPhone>
                        <Logout onClick={this.settingLogout}>退出登录</Logout>
                    </MoreSetting>
                }
                {
                    showChooseLevel && levelInfo &&
                    <ChooseLevel
                        data={levelInfo}
                        successChooseLevelHandler={this.handleSuccessChooseLevel.bind(this)}
                        clickCloseHandler={this.handleChooseLevelClose.bind(this)}
                    />
                }
                {
                    showClearHistoryDialog &&
                    <ClearHistory
                        cancleHandler={this.cancleHandler}
                    />
                }
                {showDeviceManagement &&
                    <DeviceManagement
                        handleBack={this.handleDeviceManagementBack.bind(this)}
                    />
                }
            </SettingStyled >
        )
    }
}

Setting.contextTypes = {
    user: PropTypes.object,
    clearUser: PropTypes.func
}

const SettingStyled = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    background: #fff;
`;

const BackButton = styled.div`
    position: fixed;
    top: 0.24rem;
    left: 0.64rem;
    width: 0.88rem;
    height: 0.8rem;
    background: url(${require('../../static/img/set_img/icon_back@2x.png')}) no-repeat center;
    background-size: contain;
    cursor: pointer;
    z-index: 10;
`;

const BaseSetting = styled.div`
    position: relative;
    margin: 0 auto;
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    background: #fff;
    padding-bottom: 1.28rem;

    &::after {
        position: absolute;
        content: '';
        display: block;
        top: 0;
        width: 100%;
        height: 3.89rem;
        background: url(${require('../../static/img/set_img/background.png')}) no-repeat center top;
        background-size: 100% 100%;
        z-index: 0;
    }
`;

const MoreSetting = styled.div``;

const UserInfo = styled(Flex)`
    position: relative;
    width: 6.5rem;
    height: 1.18rem;
    margin: 0.66rem auto 0.4rem;
    justify-content: center;
    z-index: 2;

    >div:nth-child(2), >div:nth-child(3) {
        margin-top: 0.75rem;
    }
`;

const Photo = styled.div`
    position: relative;
    width: 1.2rem;
    height: 1.2rem;
    border-radius: 50%;
    margin-left: 0.4rem;
    background: url(${props => props.src ? props.src : ''}) no-repeat center;
    background-size: contain;
    cursor: pointer;

    &::after {
        position: absolute;
        content: '';
        display: block;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        -webkit-transform: translate(-50%, -50%);
        width: 1.54rem;
        height: 1.54rem;
        background: url(${props => props.borderSrc || ''}) no-repeat center;
        background-size: contain;
    }
`;

const Gender = styled.div`
    width: 0.39rem;
    height: 0.39rem;
    margin-left: 0.53rem;
    margin-right: 0.21rem;
    background: url(${props => props.gender ? require('../../static/img/set_img/girl_icon.png') : require('../../static/img/set_img/icon_boy.png')}) no-repeat center;
    background-size: contain;
`;

const Name = styled.div`
    flex: 1;
    color: #fff;
    font-size: 0.38rem;
    height: 0.39rem;
    padding-left: 0.29rem;
    border-left: 1px solid rgba(101,49,168,0.2);

    >span:nth-child(1) {
        line-height: 0.5rem;
        display: inline-block;
        max-width: 2.5rem;
        overflow: hidden; 
        text-overflow: ellipsis; 
        -o-text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 0.2rem;
        margin-top: -0.05rem;
    }

    >span:nth-child(2) {
        vertical-align: middle;
        margin-top: -0.2rem;
        display: inline-block;
    }
`;

const Message = styled.div`
    position: absolute;
    top: -0.42rem;
    right: 0;
    width: 0.7rem;
    height: 0.7rem;
    background: url(${require('../../static/img/set_img/icon_xxtz.png')}) center no-repeat;
    background-size: contain;
    cursor: pointer;

    >span {
        position: absolute;
        top: 0;
        left: 0.55rem;
        height: 0.25rem;
        padding: 0 0.05rem;
        border-radius: 0.25rem;
        font-size: 0.2rem;
        background: #FA4D4D;
        color: #FFF;
    }
`;

const AchievementBox = styled(Flex)`
    position: relative;
    margin: 0.35rem auto 0.5rem;
    width: 6.63rem;
    justify-content: space-around;
    z-index: 1;

    >div:not(:last-child) {
        border-right: 0.02rem solid rgba(101,49,168,0.2);
    }
`;

const AchievementItem = styled.div`
    height: 0.64rem;
    text-align: center;
    flex: 1;
    line-height: 0.38rem;

    >div:nth-child(1) {
        color: #7457F2;
        font-size: 0.38rem;
    }

    >div:nth-child(2) {
        color: #6F56DF;
        font-size: 0.19rem;
    }

    ${props => !props.unClickable ? `
        cursor: pointer;
    ` : ``}
`;

const H5BannerBox = styled(Flex)`
    position: relative;
    margin: 0 auto;
    width: 6.63rem;
    padding: 0.32rem 0.53rem;
    background: #fff;
    /* justify-content: space-between; */
    justify-content: space-around;
    box-shadow: 0px 3px 9px rgba(0, 0, 0, 0.08);
    border-radius: 0.3rem;
    z-index: 2;

    >div:not(:last-child) {
        margin-right: 0.6rem;
    }
`;

const H5BannerItem = styled.div`
    font-size: 0.22rem;
    color: #333;
    cursor: pointer;
`;

const H5BannerItemPhoto = styled.div`
    width: 100%;
    height: 0.74rem;
    margin-bottom: 0.13rem;
    background: url(${props => props.src ? props.src : ''}) no-repeat center;
    background-size: contain;
`;

const PhotoBannerBox = styled.div`
    width: 7.14rem;
    height: 2.5rem;
    margin: 0.35rem auto 0.11rem;
`;

const PhotoBannerHeader = styled(Flex)`
    flex-direction: row;
    justify-content: space-between;
`;

const PhotoBannerHeaderText = styled.div`
    color: #333;
    font-size: 0.29rem;
    line-height: 0.4rem;
    padding-left: 0.19rem;
    font-weight: 700;
`;

const PhotoBannerHeaderH5 = styled(Flex)`
    flex-direction: row;
    color: #FF8B17;
    font-size: 0.26rem;
    padding-right: 0.19rem;
    cursor: pointer;

    >div:nth-child(2) {
        line-height: 0.42rem;
        margin: 0 0.05rem;
    }
`;

const H5Icon = styled.div`
    width: 0.27rem;
    height: 100%;
    background: url(${props => props.icon || ''}) no-repeat center;
    background-size: contain;
`;

const H5IconGo = styled.div`
    width: 0.29rem;
    height: 100%;
    background: url(${require('../../static/img/set_img/icon_go_v2.png')}) no-repeat center;
    background-size: contain;
`;

const PhotoBannerContainer = styled(Flex)`
    position: relative;
    width: 100%;
    justify-content: space-between;
`;

const PhotoBannerItem = styled.div`
    width: 3.14rem;
    height: 1.68rem;
    color: #fff;
    padding: 0.27rem 0.22rem 0.22rem 0.22rem;
    cursor: pointer;
    background: url(${props => props.icon || ''}) no-repeat center;
    background-size: 100% 100%;
    margin: 0.22rem 0.23rem 0.17rem 0.23rem;

    >div:nth-child(1) {
        font-size: 0.35rem;

        >span {
            display: inline-block;
            vertical-align: middle;

            &:nth-child(1) {
                font-size: 0.38rem;
            }

            &:nth-child(2) {
                margin: 0.15rem 0 0 0.1rem;
                font-size: 0.19rem;
            }
        }
    }

    >div:nth-child(2) {
        font-size: 0.29rem;
        font-weight: 900;
    }

    >div:nth-child(3) {
        position: relative;
        width: 2.7rem;
        height: 0.56rem;
        line-height: 0.56rem;
        border-radius: 0.28rem;
        font-size: 0.25rem;
        padding-right: 0.1rem;
        margin-top: 0.21rem;
        text-align: center;

        &::after {
            position: absolute;
            content: '';
            display: block;
            top: 0;
            right: 0.7rem;
            width: 0.07rem;
            height: 100%;
        }
    }

    ${props => props.type && props.type === 'promotion_big_button_2' ? `
        >div:nth-child(2) {
            color: #965D15;
        }

        >div:nth-child(3) {
            color: #fff;
            background: #FA6400;
            
            &::after {
                background: url(${require('../../static/img/set_img/icon_sj_white_v2.png')}) no-repeat center;
                background-size: contain;
            }
        }
    ` : `
        >div:nth-child(2) {
            color: #A55824;
        }

        >div:nth-child(3) {
            color: #FF800E;
            background: transparent;
            border: 0.02rem solid #F18E35;

            &::after {
                top: 0.03rem;
                width: 0.08rem;
                background: url(${require('../../static/img/set_img/icon_sj_orange_v2.png')}) no-repeat center;
                background-size: contain;
            }
        }
    `}
`;

const SettingCard = styled.ul`
    margin: 0.11rem auto 0.32rem;
    width: 6.63rem;
    padding: 0 0.32rem;
    background: #fff;
    box-shadow: 0 0.05rem 0.14rem 0 rgba(0, 0, 0, 0.08);
    border-radius: 0.3rem;
    box-sizing: border-box;

    >li:not(:last-child) {
        border-bottom: 0.02rem solid rgba(233,233,233,1);
    }
`;

const ListItem = styled.li`
    position: relative;
    width: 100%;
    color: #333333;
    font-size: 0.26rem;
    line-height: 0.96rem;
    padding-left: 0.61rem;
    background: url(${props => props.icon || ''}) no-repeat 0rem center;
    background-size: 0.45rem 0.45rem;
    cursor: pointer;

    ${props => props.hasArrow ? `
        &::after {
            position: absolute;
            content: '';
            display: block;
            top: 0;
            right: 0;
            width: 0.29rem;
            height: 100%;
            background: url(${require('../../static/img/set_img/icon_go.png')}) no-repeat center;
            background-size: contain;
        }
    ` : ''}
`;

const Pause = styled.div`
    float: right;
    width: 0.83rem;
    height: 0.51rem;
    margin-top: 0.22rem;
    border-radius: 0.26rem;
    background-color: #E5E5E5;
    cursor: pointer;

    span {
        float: left;
        width: 0.42rem;
        height: 0.42rem;
        margin: 0.05rem 0 0 0.05rem;
        border-radius: 0.21rem;
        background-color: #fff;
    }

    &.on {
        background-color: #A46CFD;
        span {
            float: right;
            margin: 0.05rem 0.05rem 0 0;
        }
    }
`;

const MoreSettingTitle = styled.div`
    margin: 0 auto 0.32rem;
    padding-top: 0.66rem;
    text-align: center;
    color: #333;
    font-size: 0.36rem;
    font-weight: 700;
`;

const MoreSettingPhone = styled.div`
    text-align: center;
    margin-top: 0.96rem;
    font-size: 0.28rem;
    color: #999999;
`;

const Logout = styled.div`
    margin: 0.26rem auto;
    width: 4.83rem;
    height: 0.9rem;
    line-height: 0.9rem;
    box-shadow: 0 0.04rem 0.2rem 0 rgba(0,0,0,0.1);
    font-size: 0.29rem;
    color: #333;
    text-align: center;
    border-radius: 0.5rem;
    cursor: pointer;
`;



// WEBPACK FOOTER //
// ./src/route/version-2/Setting-2.js